import React from 'react';
import PropTypes from 'prop-types';

class Activity extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDescription = this.toggleDescription.bind(this);
    this.state = { isOpen: false };
  }

  toggleDescription() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  renderActivityDescription() {
    const description = { __html: this.props.description };
    return <div className="activity-body" dangerouslySetInnerHTML={description} />;
  }

  renderActivityActions() {
    const { isOpen } = this.state;
    return (
      <div className="activity-actions">
        { isOpen ? <span>Less Details</span> : <span>More Details</span> }
        <i className={isOpen ? 'caret caret-up' : 'caret caret-down'} />
      </div>
    );
  }

  render() {
    const {
      timeFormatted,
      categoryName,
      title,
      description,
    } = this.props;

    return (
      <li className="activity">
        <button
          className="activity-header"
          type="button"
          onClick={this.toggleDescription}
        >
          <div className="activity-time">
            { timeFormatted }
          </div>
          <div className="activity-content">
            <h3 className="activity-title">{ title }</h3>
            { categoryName }
          </div>
          { Boolean(description) && this.renderActivityActions() }
        </button>
        { this.state.isOpen && this.renderActivityDescription() }
      </li>
    );
  }
}

Activity.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  timeFormatted: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
};

export default Activity;



// WEBPACK FOOTER //
// ./components/activity-list/activity/index.js